import { defineStore } from 'pinia';
import { reqUserInfo } from "@/api";

export const useMainStore = defineStore('main', {
    state: () => ({
        // token
        token: localStorage.getItem("token") || "",

        // 用户信息
        userInfo: localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {},

        // 实名认证信息
        userCertInfo: localStorage.getItem("userCertInfo") ? JSON.parse(localStorage.getItem("userCertInfo")) : {},

        // 项目流程
        projectDetail: localStorage.getItem("projectDetail") ? JSON.parse(localStorage.getItem("projectDetail")) : [],

        // 初始化配置
        initProject: localStorage.getItem("initProject") ? JSON.parse(localStorage.getItem("initProject")) : {}
    }),

    getters: {
        // getters directly return the state in Pinia, and they are cached
        getToken: (state) => state.token,
        getUserInfo: (state) => state.userInfo,
        getUserCertInfo: (state) => state.userCertInfo,
        getProjectDetail: (state) => state.projectDetail,
        getInitProject: (state) => state.initProject,
    },

    actions: {
        changeToken(obj) {
            this.token = obj;
            if (obj) {
                localStorage.setItem("token", JSON.stringify(obj));
            } else {
                localStorage.removeItem("token");
            }
        },

        changeUserInfo(obj) {
            this.userInfo = obj;
            if (obj && obj.id) {
                localStorage.setItem("userInfo", JSON.stringify(obj));
            } else {
                localStorage.removeItem("userInfo");
            }
        },

        changeUserCertInfo(obj) {
            this.userCertInfo = obj;
            if (obj && obj.id) {
                localStorage.setItem("userCertInfo", JSON.stringify(obj));
            } else {
                localStorage.removeItem("userCertInfo");
            }
        },

        changeProjectDetail(arr) {
            this.projectDetail = arr;
            localStorage.removeItem("active");
            if (arr) {
                localStorage.setItem("active", arr.current_step);
                localStorage.setItem("projectDetail", JSON.stringify(arr));
            } else {
                localStorage.setItem("active", "0");
                localStorage.removeItem("projectDetail");
            }
        },

        changeInitProject(obj) {
            this.initProject = obj;
            if (obj) {
                localStorage.setItem("initProject", JSON.stringify(obj));
            } else {
                localStorage.removeItem("initProject");
            }
        },

        // 复合业务 Actions
        updateToken(obj) {
            this.changeToken(obj);
        },

        // fetch userInfo asynchronously
        async fetchAndSetUserInfo(obj) {
            try {
                const res = await reqUserInfo();
                if (res.data.code === 1) {
                    this.changeUserInfo(res.data.data.userinfo);
                }
            } catch (e) {
                console.error("Failed to fetch user info", e);
            }

            // Fallback object mutation if passed
            if (obj) {
                this.changeUserInfo(obj);
            }
        },

        updateUserCertInfo(obj) {
            this.changeUserCertInfo(obj);
        },

        updateUserInfo(obj) {
            this.changeUserInfo(obj);
        },

        updateProjectDetail(arr) {
            this.changeProjectDetail(arr);
        },

        updateInitProject(obj) {
            this.changeInitProject(obj);
        },

        /**
         * Centralized logout action.
         * Clears all user state and localStorage entries.
         */
        logout() {
            this.token = '';
            this.userInfo = {};
            this.userCertInfo = {};
            this.projectDetail = [];
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('userCertInfo');
            localStorage.removeItem('projectDetail');
            localStorage.removeItem('active');
            localStorage.removeItem('currentStepName');
        }
    }
});
